import { useRouter } from 'next/router';

export default function useIsMobileURL(): boolean {
  const { query } = useRouter();
  return !!query?.device?.includes('m');
}
